<div class="container convList" [ngClass]="{'loading' : loading}">
  <div class="page-bg">
    <div class="convList__topToolbar topToolbar" *ngIf="!noConversationsInfo">
      <mat-checkbox class="topToolbar__selectAll" [(ngModel)]="selectAllCheckbox" (change)="selectAllConversations($event)">Select all</mat-checkbox>
      <div class="topToolbar__boxWhenSelect" *ngIf="selectedConvCount > 0">
        <span class="topToolbar__selectedCount" >
          Number of selected: {{selectedConvCount}}
        </span>
        <button  class="topToolbar__deleteBt" mat-flat-button color="primary" (click)="deleteSelectedConv()">
          Delete Selected
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    <div class="convList__conversationsWrap container pt-2 mb-2">
      <div class="convList__noMessageInfo" *ngIf="noConversationsInfo">
        Inbox is empty
      </div>
      <div class="convList__loaderSpinner loader-spinner" *ngIf="loading">
        <div class="loadingio-spinner-spinner-32cs6uvfc5">
          <div class="ldio-1tl0ero9yn7">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
          </div>
        </div>
      </div>
      <div class="convList__refreshSpinner d-flex justify-content-center pb-3" *ngIf="!loading && refreshingLastList">
        <mat-spinner diameter="20"></mat-spinner>
      </div>
      <ng-container *ngFor="let conversation of conversations; let i = index">
        <div class="adsContainer"
            *ngIf="!loading && mainService.advService.bannersEnabled && (!isPremium || !mainService.enableSubscription) && i + 1 != conversations.length && i % 8 == 0">
          <app-banner-zone-map [zoneType]="['Desktop-Zone-Horizontal-Top', 'Desktop-Zone-Horizontal-Bottom']"></app-banner-zone-map>
        </div>

      <mat-expansion-panel #convList [expanded]="activeConversationId == conversation.conversationId" (click)="setUrlId(conversation.conversationId)" (opened)="setReadedMessages(conversation)" [ngClass]="'conversation-'+conversation.conversationId" class="convList__conversations">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="convList__conversation-title-container">
              <mat-checkbox #checboxList class="convList__conversationSelect" [id]="conversation.conversationId" (click)="$event.stopPropagation()" (change)="selectConversation($event,i)"></mat-checkbox>
              <span class="convList__conversation-date"><button style="transform: scale(0.7)" *ngIf="conversation.hasNewMessages" mat-flat-button color="accent">NEW</button> <button style="transform: scale(0.7)" *ngIf="showDemoAdInfo(conversation)" mat-stroked-button>DEMO AD</button> {{conversation.creationDate.format("MM/DD/YYYY hh:mm A")}}&nbsp;</span>
              <span class="convList__conversation-from">From:</span>
              <span class="convList__conversation-nick">[{{this.resolveConversationSenderNick(conversation)}}]</span>
              <span class="convList__conversation-title"><a [routerLink]="['/adv-detail/' + conversation.advertisementId + '/c/' + conversation.conversationKey ]">{{conversation.advTitle}}</a></span>
              <button class="convList__conversation-delete-button" (click)="deleteConversation(conversation.conversationId, i)" mat-button style="float: right" title="Delete conversation">
                <mat-icon>delete</mat-icon>
              </button>
              <mat-spinner class="convList__conversation-loader" diameter="20"></mat-spinner>
            </div>

          </mat-panel-title>
          <!--      <mat-panel-description>-->
          <!--        {{conversation.receiverEmail}}-->
          <!--      </mat-panel-description>-->
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div *ngFor="let message of conversation.messages; let j = index" class="convList__message-item">
            <span class="convList__message-date">{{message.creationDate.format("MM/DD/YYYY hh:mm A")}}&nbsp;</span>
            <span class="convList__message-from">From:</span>
            <span class="convList__message-title">[{{this.resolveMessageSenderNick(conversation,message)}}]</span>
            <div class="convList__message-content">{{message.content}}</div>
            <div *ngIf="hasImages(conversation.conversationId,message.conversationMessageId)" style="width:50%; margin: auto">
             <ngx-gallery [images]="images[conversation.conversationId][message.conversationMessageId]" [options]="galleryOptions" class="w-100"></ngx-gallery>
            </div>
          </div>
          <conv-send-message [captchaEnabled]="false" [isNotFirstMessage]="true" (submitClick)="sendConversationMessage($event, conversation.conversationId)" [currentConversation]="conversation"></conv-send-message>
        </ng-template>


      </mat-expansion-panel>
       
      </ng-container>

      <mat-toolbar class="w-100" color="transparent-bg" *ngIf="perPage != 0 && allConversationsCount > 0  && allConversationsCount > perPage" style="background: #f9f9f9;">
        <mat-toolbar-row class="p-0 mt-2" fxLayout="row" fxLayoutAlign="end center" >
          <mat-paginator (page)="pageEvent = $event"
                         [length]="allConversationsCount"
                         [pageIndex]="page"
                         [pageSizeOptions]="pageSizeOptions"
                         [pageSize]="perPage"
                         (page)="pageChange($event)"></mat-paginator>
        </mat-toolbar-row>
      </mat-toolbar>
    </div>
  </div>


</div>

